<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  (click)="onHeadphonesClick()"
>
  <title>{{ muted ? "Unmute" : "Mute" }}</title>
  <path
    d="M8.00005 2.21411C4.04539 2.21411 0.800049 5.15567 0.800049 8.77147V11.8573C0.800049 12.4954 1.36778 13.0145 2.06567 13.0145H2.48755V9.1572H2.06567C1.91706 9.1572 1.77641 9.18502 1.6438 9.22825V8.77147C1.6438 5.58094 4.51052 2.98557 8.00005 2.98557C11.4896 2.98557 14.3563 5.58094 14.3563 8.77147V9.22825C14.2237 9.18502 14.083 9.1572 13.9344 9.1572H13.5125V13.0145H13.9344C14.6323 13.0145 15.2 12.4954 15.2 11.8573V8.77147C15.2 5.15567 11.9547 2.21411 8.00005 2.21411Z"
    [ngStyle]="{ fill: muted ? _offColor : fillColor }"
  />
  <path
    d="M4.59692 8.38574H4.17505C3.70905 8.38574 3.3313 8.73112 3.3313 9.1572V13.0145C3.3313 13.4405 3.70905 13.7859 4.17505 13.7859H4.59692C4.82991 13.7859 5.0188 13.6132 5.0188 13.4002V8.77147C5.0188 8.55845 4.82991 8.38574 4.59692 8.38574Z"
    [ngStyle]="{ fill: muted ? _offColor : fillColor }"
  />
  <path
    d="M11.8242 8.38574H11.4023C11.1694 8.38574 10.9805 8.55845 10.9805 8.77147V13.4002C10.9805 13.6132 11.1694 13.7859 11.4023 13.7859H11.8242C12.2902 13.7859 12.668 13.4405 12.668 13.0145V9.1572C12.668 8.73112 12.2902 8.38574 11.8242 8.38574Z"
    [ngStyle]="{ fill: muted ? _offColor : fillColor }"
  />
</svg>
